/*
 * @providesModule SecureBankingDrawerStyles
 */
import {StyleSheet} from 'react-native';

import {default as SkillzStyle} from 'SkillzStyle';

const {fontRegular, fontExtraBold, fontMedium} = SkillzStyle.fullStyles;

export const styles = StyleSheet.create({
  shieldIcon: {
    width: 17,
    height: 19,
    flexShrink: 0,
  },

  // SECURITY DRAWER STYLES
  securityDrawerContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingTop: 8,
    paddingBottom: 16,
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    backgroundColor: '#FFF',
  },

  securityDrawerHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: -10,
  },

  securityDrawerShieldIcon: {
    width: 17,
    height: 19,
    flexShrink: 0,
    marginRight: 8,
    marginBottom: 20,
    marginTop: -10,
  },

  securityDrawerTitle: {
    color: '#333',
    ...fontExtraBold,
    fontSize: 16,
    letterSpacing: -0.48,
    textAlign: 'center',
    marginBottom: 20,
    marginTop: -10,
  },

  securityDrawerBodyContainer: {
    paddingVertical: 8,
    width: '100%',
    paddingHorizontal: 20,
    alignItems: 'center',
  },

  securityDrawerBodyText: {
    color: '#424242',
    ...fontRegular,
    fontSize: 13,
    lineHeight: 18,
    letterSpacing: -0.13,
    marginBottom: 8,
    alignSelf: 'flex-start',
    marginLeft: 15,
  },

  securityDrawerLinkText: {
    color: '#367BCE',
    ...fontRegular,
    fontSize: 13,
    letterSpacing: -0.13,
    lineHeight: 18,
    textDecorationLine: 'underline',
    alignSelf: 'flex-start',
    marginLeft: 15,
  },

  footerToastContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },

  securityButtonText: {
    color: '#FFF',
    textAlign: 'center',
    ...fontMedium,
    fontSize: 16,
    fontStyle: 'normal',
    lineHeight: 24,
  },
});

export const stylesFn = (isDrawerShowing: boolean) =>
  StyleSheet.create({
    footerToastContainer: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      top: isDrawerShowing ? 0 : '100%',
      backgroundColor: isDrawerShowing ? 'rgba(0, 0, 0, 0.5)' : 'transparent',
    },
  });
